import React from 'react';
import styled from 'styled-components';
import Alert from 'antd/es/alert';

export const ChangeDisclaimer = () => (
    <Disclaimer
        message={`Changes made here will be reflected on our public AI2 website`}
        type="info"
        banner
        showIcon
    />
);

const Disclaimer = styled(Alert)`
    margin-bottom: ${({ theme }) => theme.spacing.lg};
`;
